/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SyncEntityProductDiaryPage = lazyLoad(
  () => import('./index'),
  module => module.SyncEntityProductDiaryPage
);
